module.exports = new __parcel__URL__("testimoni-johny.331dada6.webp").toString();